import { BackendOffZone } from 'shared/types';
import { Polygon } from 'store/mapDrawingSlice';

export const parseOffZone = ({ id, boundLatitudes, boundLongitudes }: BackendOffZone): Polygon =>
  ({
    id,
    path: boundLatitudes.map((lat, i) => ({ lat, lng: boundLongitudes[i] })),
  } as unknown as Polygon);
